var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import common from '../../Common/Simple.edit.display';
export default __spreadArray(__spreadArray([], common, true), [
    {
        key: 'placeholder',
        ignore: true
    },
    {
        key: 'refreshOnChange',
        ignore: true
    },
    {
        key: 'className',
        ignore: true,
    },
    {
        key: 'prefix',
        ignore: true
    },
    {
        key: 'suffix',
        ignore: true
    },
    {
        key: 'inputMask',
        ignore: true
    },
    {
        key: 'allowMultipleMasks',
        ignore: true
    },
    {
        key: 'showWordCount',
        ignore: true,
    },
    {
        key: 'showCharCount',
        ignore: true,
    },
], false);
